/* eslint-disable react/require-default-props */
import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import { Link } from 'react-router-dom'
import { colors } from '../../../theme/palette'
import { useWindowResize } from '../../../hooks/useWindowSize'
import breakpoints from '../../../theme/breakpoints'
import { Button } from '../Button/Button'

type RuleNames = 'row' | 'withHover' | 'wrapper'

interface StyleProps {
    gridTemplateColumns?: string
    minHeight?: string
}

type Props = {
    gridTemplateColumns?: string
    url?: string | undefined
    minHeight?: string
    onClick?: () => void
    useHover?: boolean
    useCursor?: boolean
    showFooter?: boolean
    footer?: any
}

const useStyles = createUseStyles<RuleNames, StyleProps, Jss.Theme>(() => ({
    row: ({ gridTemplateColumns, minHeight }) => {
        return {
            position: 'relative',
            backgroundColor: colors.white,
            width: '100%',
            color: 'black',
            display: 'grid',
            gridTemplateColumns,
            minHeight: minHeight || '65px',
        }
    },
    wrapper: {
        borderRadius: '4px',
        marginBottom: '5px',
        backgroundColor: colors.white,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'visible',
    },
    withHover: {
        transition: '.15s ease-in',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
        },
    },
}))

const Card: React.FC<Props> = ({
    gridTemplateColumns = 'repeat( auto-fit, minmax(1px, 1fr) )',
    url,
    minHeight,
    children,
    onClick,
    useHover,
    showFooter,
    footer,
    useCursor,
}) => {
    const windowSize = useWindowResize()
    const theme = useTheme<Jss.Theme>()
    const classes = useStyles({ ...{ gridTemplateColumns, minHeight }, theme })

    if (windowSize.width >= breakpoints.Desktop) {
        if (url) {
            return (
                <div className={classes.wrapper}>
                    <Link
                        tabIndex={0}
                        className={`${classes.row} ${classes.withHover}`}
                        to={url}
                    >
                        {children}
                    </Link>
                </div>
            )
        }

        return (
            <div className={classes.wrapper}>
                <div
                    role="button"
                    tabIndex={-1}
                    className={`${classes.row} ${
                        useHover ? classes.withHover : ''
                    }`}
                    onKeyDown={onClick}
                    onClick={onClick}
                    style={{
                        cursor: onClick || useCursor ? 'pointer' : 'inherit',
                    }}
                >
                    {children}
                </div>
                {footer && showFooter ? <div>{footer}</div> : null}
            </div>
        )
    }

    return null
}

Card.defaultProps = {
    useHover: false,
}

export { Card }
